import { render } from "./DebtCard.vue?vue&type=template&id=ac528aba&scoped=true"
import script from "./DebtCard.vue?vue&type=script&lang=js"
export * from "./DebtCard.vue?vue&type=script&lang=js"

import "./DebtCard.vue?vue&type=style&index=0&id=ac528aba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac528aba"]])

export default __exports__